// extracted by mini-css-extract-plugin
export default {"wrapper":"AssessmentPanelFilter_wrapper__MFTH0"};